module.exports = __webpack_public_path__ + "img/bb_g3_t_ears-03.88a71202.svg";